import React from "react";
import { Header } from "../Header";
import { HeaderTitle } from "../HeaderTitle";
import styles from "./layout.module.scss";
// import favIcon from "assets/img/favicon.ico";

interface LayoutProps {
    children?: any;
    title: string;
    subtitle: string;
}

export const Layout: React.FC<LayoutProps> = ({
    children,
    title,
    subtitle,
}) => {
    const optionsTop = [
        "Inscreva-se na newsletter",
        "Como Comprar",
        "Quero Vender",
        "Blog",
        "Ajuda",
        "Fale Conosco",
    ];

    return (
        <div className={styles.container}>
            <Header optionsTop={optionsTop} />
            <div className={styles.content}>
                <HeaderTitle title={title} subtitle={subtitle} />

                {children}
            </div>
        </div>
    );
};
